import styled from '@emotion/styled';
import { Add, Delete } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { Box } from '@mui/system';
import { memo } from 'react';

type Props = {
    id: number;
    displayName: string;
    isCreateDisabled: boolean;
    isDeleteDisabled: boolean;
    handleNewCustomer(id: number): void;
    handleDeleteCustomer(id: number): void;
};

const CustomerTreeItem = ({
    id,
    displayName,
    isCreateDisabled,
    isDeleteDisabled,
    handleDeleteCustomer,
    handleNewCustomer
}: Props) => {
    return (
        <StyledBox component="div">
            <Box className="customerLabel" component="span">
                {displayName}
            </Box>
            {(!isCreateDisabled || !isDeleteDisabled) && (
                <Box sx={{ alignItems: 'flex-end' }}>
                    <Box sx={{ display: 'inline-flex' }} component="div">
                        <Tooltip sx={{ mr: 0 }} title={`Create new customer below ${displayName}`}>
                            <Box component="span">
                                <IconButton
                                    onClick={() => handleNewCustomer(id)}
                                    color="primary"
                                    disabled={isCreateDisabled}
                                    size="small"
                                >
                                    <Add />
                                </IconButton>
                            </Box>
                        </Tooltip>
                        <Tooltip sx={{ ml: 0 }} title={`Delete customer ${displayName}`}>
                            <Box component="span">
                                <IconButton
                                    onClick={() => handleDeleteCustomer(id)}
                                    color="secondary"
                                    disabled={isDeleteDisabled}
                                    size="small"
                                >
                                    <Delete />
                                </IconButton>
                            </Box>
                        </Tooltip>
                    </Box>
                </Box>
            )}
        </StyledBox>
    );
};

export default memo(CustomerTreeItem);

const StyledBox = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    maxHeight: '25px',
    justifyContent: 'space-between',
    '& > div ': {
        display: 'none'
    },
    '&:hover > div': {
        display: 'block'
    },
    '&:hover span': {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: '100'
    }
});
